import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage';

@Injectable()
export class SettingService {
  constructor(private storage: Storage) {}

  getAppSettings() {
    return this.storage.get('app_settings').then(val => {
      return val;
    });
  }
  setAppSettings(setting) {
    this.storage.set("app_settings", setting);
  }

}



// WEBPACK FOOTER //
// ./src/services/setting-service.ts